import React from "react";
import Standings from "./components/Standings";
import Schedule from "./components/Schedule";
import "./styles/general.css";

function App() {
    return (
        <div className="app-container">
            <h1 className="title">Football League</h1>
            <Standings />
            <Schedule />
        </div>
    );
}

export default App;
